import { useEffect } from "react";
import { Navigate, useOutletContext, useParams } from "react-router-dom";
import { Section } from "@/components/site/Sections";

export default function PublicPage({ slug: fixed }) {
  const params = useParams();
  const site = useOutletContext();
  const slug = fixed || params.slug;
  const page = site.pages.find((p) => p.slug === slug);
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  if (!page) return slug === "home" ? <div className="p-20 text-center" data-testid="no-page">Coming soon.</div> : <Navigate to="/" replace />;
  return (
    <div data-testid={`page-${slug}`}>
      {page.sections.map((s) => <Section key={s.id} s={s} settings={site.settings} />)}
    </div>
  );
}
